const TrackingTargetViewModuleConstants = {
    rootStateName: "trackingTarget",
    prevStateLabel: "tracking-target"
};

export default Object.freeze(TrackingTargetViewModuleConstants);



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-targets-view/Constants.js
// module id = LUOv
// module chunks = 1